/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Billing } from '../../models/billing';

export interface BillingGetDetail$Params {
  BillingId?: string | null;
}

export function billingGetDetail(http: HttpClient, rootUrl: string, params?: BillingGetDetail$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Billing>>> {
  const rb = new RequestBuilder(rootUrl, billingGetDetail.PATH, 'get');
  if (params) {
    rb.query('BillingId', params.BillingId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Billing>>;
    })
  );
}

billingGetDetail.PATH = '/billing/getdetails';
